<template>
  <div>
    <div id="print-report">
      <!-- PRINT ONLY -->
      <div class="caption d-none d-print-block mb-3">
        <HeaderPrint />
        <div>
          {{ $t("FilteredPeriod") }}:
          {{ $date.formatRange(rangeDate) }}
        </div>
      </div>
      <!-- end/ PRINT ONLY -->
      <v-card class="mb-3">
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left> mdi-printer </v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                solo-inverted
                dense
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          @current-items="resume"
          :items-per-page="-1"
          :hide-default-footer="true"
          sort-by="bets_sales"
          :sort-desc="true"
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template
            v-for="(key, index) in headers"
            v-slot:[`item.${key.value}`]="{ item }"
          >
            <!-- <span :key="index" :class="getColor(item[key])">{{
              item[key]
            }}</span> -->

            <a
              v-if="index == 0"
              :key="key + index"
              @click="
                $profile.showProfileDrawer(
                  item.agent_id,
                  'localManager/agents/getAgent'
                )
              "
            >
              {{ item.agent_name }}
            </a>

            <span
              v-else
              class="caption"
              :key="key + index"
              :class="getColor(item[key.value], index)"
              >{{ item[key.value] }}</span
            >
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="items.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}

                <v-icon class="float-right mr-3" @click="$copy(resumeCopy)">
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("qtdBets") }}</td>
                      <td class="text-right caption">
                        {{ some.countBet || 0 }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("grossValue") }}</td>
                      <td class="text-right caption">
                        <span :class="getColor(some.salesBets)">{{
                          some.salesBets || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("agentCommissions") }}</td>
                      <td class="text-right caption">
                        <span :class="getColor(some.agentCommission)">{{
                          some.agentCommission || 0
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("comissionGerLocal") }}</td>
                      <td class="text-right caption">
                        <span :class="getColor(some.commissionLocal)">{{
                          some.commissionLocal || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("awards") }}</td>
                      <td class="text-right caption">
                        <span :class="getColor(some.prizesPaid)">{{
                          some.prizesPaid || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("groosProfit") }}</td>
                      <td class="text-right caption">
                        <span :class="getColor(some.grossProfit)">{{
                          some.grossProfit || 0
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";

export default {
  name: "local-manager-financial-apuration",
  components: {
    HeaderPrint,
  },
  data: () => ({
    breakpoint: "xs",
    items: [],
    search: "",
    some: {},
    resumeCopy: "",
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("agent"), value: "agent_name", align: "start" },
        { text: this.$t("qtyBets"), value: "bets_count", align: "center" },
        { text: this.$t("bets"), value: "bets_sales", align: "center" },
        { text: this.$t("awards"), value: "prizes_paid", align: "center" },
        {
          text: this.$t("coAgentBet"),
          value: "agent_commission",
          align: "center",
        },
        {
          text: this.$t("coGerLocal"),
          value: "comission_local",
          align: "center",
        },
        {
          text: this.$t("grossProfit"),
          value: "gross_profit",
          align: "center",
        },
      ];
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
    // id_agent(val) {
    //   console.log(val);
    // },
  },

  methods: {
    resetPage() {
      this.some = {};
      // this.search = "";
    },

    async requestApi() {
      this.resetPage();

      const body = {
        ...this.rangeDate,
        id_agente: this.id_agent,
        export: this.exportDoc,
      };
      let response;
      if (this.exportDoc) {
        var extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/localManager/retail/financial/salesReport",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/localManager/retail/financial/salesReport",
          body
        );
      }
      if (!response.dados) {
        this.items = [];
        return;
      }

      this.items = response.dados;
      this.items.forEach((item) => {
        if (item.type_comission == "ngr") {
          if (item.comission_ngr_local < "0") {
            item.comission_local = "0";
          } else {
            item.comission_local = Number(item.comission_ngr_local).toFixed(2);
          }
          item.gross_profit = item.gross_profit_ngr;
        } else {
          item.comission_local = Number(item.comission_local).toFixed(2);
        }
        item.agent_commission = Number(item.agent_commission) * -1;
        item.prizes_paid = Number(item.prizes_paid) * -1;
      });
      var dt_start = response.date_start.replace(" ", "T");
      var dt_end = response.date_final.replace(" ", "T");

      this.$date.buildRangeUi(dt_start, dt_end);
      // this.search estava com um bug que impedia
      // digitar valores; mover para este bloco resolveu o bug
      this.search = "";
    },

    setData(data) {
      this.resetPage();
      this.apuration = data;
    },

    resume(item) {
      this.resetPage();

      item.forEach((item) => {
        this.some.countBet =
          (this.some.countBet || 0) + Number(item.bets_count);

        this.some.salesBets =
          (this.some.salesBets || 0) + Number(item.bets_sales);

        this.some.agentCommission =
          (this.some.agentCommission || 0) + Number(item.agent_commission);

        this.some.commissionLocal =
          (this.some.commissionLocal || 0) + Number(item.comission_local);

        this.some.prizesPaid =
          (this.some.prizesPaid || 0) + Number(item.prizes_paid);

        this.some.grossProfit =
          (this.some.grossProfit || 0) + Number(item.gross_profit);
      });

      // Apenas 2 casas decimais
      if (this.some.grossProfit == undefined) return;
      this.some.grossProfit = this.some.grossProfit.toFixed(2);
      this.some.salesBets = this.some.salesBets.toFixed(2);
      this.some.agentCommission = this.some.agentCommission.toFixed(2);
      this.some.commissionLocal = this.some.commissionLocal.toFixed(2);
      this.some.prizesPaid = this.some.prizesPaid.toFixed(2);

      // To Copy
      this.some.grossProfitCopy = this.some.grossProfit
        .toString()
        .replace(".", ",");
      this.some.salesBetsCopy = this.some.salesBets
        .toString()
        .replace(".", ",");
      this.some.agentCommissionCopy = this.some.agentCommission
        .toString()
        .replace(".", ",");

      this.some.commissionLocalCopy = this.some.commissionLocal
        .toString()
        .replace(".", ",");

      this.some.prizesPaidCopy = this.some.prizesPaid
        .toString()
        .replace(".", ",");

      this.resumeCopy = `${this.some.countBet}
        ${this.some.salesBetsCopy}
        ${this.some.agentCommissionCopy}
        ${this.some.commissionLocalCopy}
        ${this.some.prizesPaidCopy}
        ${this.some.grossProfitCopy}`;
    },
    getColor(value, index) {
      if (index == 1) return;
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
